import {post, get, getFile, port, upload} from "@/utils/request";
import {postAI, getAI, deleteAI, postAIUpFile} from "@/utils/requestAI";
import {ResultModel, LoginParams,DoubaoChatParams,DoubaoStreamResponse,DoubaoModelInfo} from "@/AIApi/types";

export const login = (data: LoginParams) => post<ResultModel>('/warnWeb/login/login', data);
export const getCode = () => getFile<ResultModel>('/file/getCode');

// 根据手机号获取验证码
export const getPhoneCode = (data: any) => getAI('/api/login/getVerCode', data);
// 手机号码登录
export const phoneLogin = (data: any) => getAI('/api/login/loginByMobile', data);
// 账号登录
export const accountLogin = (data: any) => getAI('/api/login/loginByUserName', data);
// 登出接口
export const logout = (data:any) => postAI('/api/login/logout', data);

// 获取对话记录列表
export const getAIHistoryList = (data:any) => getAI('/api/session/list?',data);

// 创建新聊天
export const addAiRecord = (data:any) => postAI('/api/session/create',data);

// 获取聊天上下文
export const getAIcontext = (sessionId: string,data:any) => getAI(`/api/session/${sessionId}/messages`,data);

// 会话重命名
export const renameAI = (sessionId:string,data:any) => postAI(`/api/session/update/${sessionId}`,data);

// 删除对话
export const deleteAIRecord = (sessionId: string) => deleteAI(`/api/session/${sessionId}`);

// 上传训练文件
export const upLoadKnowledgeBaseFile = (data:any) => postAIUpFile('/knowledge/upLoadKnowledgeBaseFile',data);
// 获取知识库文件列表
export const getDocumentList = (data:any) => getAI('/knowledge/getDocumentList',data);
// 删除知识库文件
export const deleteDocument = (fileIds:string,data:any) => postAI(`/knowledge/deleteDocument?fileIds=${fileIds}`,data);
